import React, { useEffect } from 'react';
import clsx from 'clsx';
import { Product } from '@interfaces/models/product';
import { useBucketTestEvents } from '@hooks/bucket-test/use-bucket-test-events';
import Environment from '@config/index';
import { useContextSelector } from 'use-context-selector';
import { ModalContext } from '@context/modal.context';
import ModalPaymentInstallment from './modal-payment-installment/modal-payment-installment';
import styles from './product-installment.module.scss';

interface ProductInstallmentProps {
  product: Product;
}

const ProductInstallment: React.FC<ProductInstallmentProps> = ({ product }) => {
  const { sendBNPLClickEvent, sendBNPLShowEvent } = useBucketTestEvents('klarna');
  const openModal = useContextSelector(ModalContext, (v) => v.openModal);

  const paymentProvider = product?.installment?.mnemonic;

  // Check if payment provider is set and included in array
  const isClickable = !!paymentProvider && ['facilypay_oney', 'klarna', 'splitit'].includes(paymentProvider);

  const openPaymentInstallmentModal = () =>
    openModal(<ModalPaymentInstallment paymentName={paymentProvider} />, {
      styles: {
        content: {
          maxWidth: paymentProvider === 'facilypay_oney' ? '100%' : '600px',
          width: '100%',
        },
      },
      onAfterOpen: () => {
        sendBNPLClickEvent('old');
      },
    });

  useEffect(() => {
    if (product.installment) {
      sendBNPLShowEvent('old');
    }
  }, [product]);

  return (
    <>
      {product.installment && (
        <div
          className={clsx(styles.productInstallment, isClickable && styles.productInstallment__link)}
          {...(isClickable && { onClick: openPaymentInstallmentModal })}
          role="presentation"
          // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
          tabIndex={isClickable ? 0 : -1}
        >
          {/* Text */}
          <p className={styles.productInstallment__text}>
            {product.installment.description.replace(product?.installment?.iconPlaceholder, '')}
          </p>
          <img
            className={clsx(styles.productInstallment__svg, styles[`productInstallment__svg--${paymentProvider}`])}
            src={`${Environment.cdnFolder}/assets/svg/carts/${paymentProvider}.svg`}
            alt={product.installment?.name}
            width={36}
            height={15}
          />
        </div>
      )}
    </>
  );
};

export default ProductInstallment;
